import React from "react";
import ProjectLanguages from "../projectLanguages/ProjectLanguages";
import "./ProjectCard.css";
import { Fade } from "react-reveal";
import { style } from "glamor";

export default function ProjectCard({ repo, theme }) {
  const styles = style({
    color: theme.secondaryText,
    backgroundColor: theme.projectCard,
    border: `1px solid ${theme.border}`,
    boxShadow: `${theme.shadow} 0px 10px 30px -15px`,
    borderRadius: "12px",
    height: "100%",
    transition: "all 0.2s ease-in-out",
    ":hover": {
      boxShadow: `${theme.shadowStrong} 0 6px 22px`,
      transform: "translateY(-4px)",
    },
  });

  return (
    <div>
      <Fade bottom duration={2000} distance="40px">
        <div
          {...styles}
          key={repo.name}
          style={{
            backgroundColor: theme.projectCard,
            backgroundImage: `linear-gradient(${theme.accentColor}22, ${theme.projectCard} max(9.5rem, 15vh))`,
          }}
          className="project-card"
        >
          {repo.image ? (
            <a href={repo.url} target="_blank" rel="noopener noreferrer">
              <img
                src={require(`../../assests/images/${repo.image}`)}
                alt={repo.alt_name}
              />
            </a>
          ) : (
            ""
          )}

          <div style={{ padding: "10px 2rem 1rem 2rem" }}>
            <div className="repo-name-div">
              <p className="repo-name" style={{ color: theme.text }}>
                {repo.name}
              </p>
            </div>
            <p
              className="experience-card-company"
              style={{ color: theme.secondaryText }}
            >
              <a href={repo.url} target="_blank" rel="noopener noreferrer">
                Repo
              </a>
              {repo.deployedSite ? (
                <a
                  href={repo.deployedSite}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginLeft: "15px" }}
                >
                  Deployed Site
                </a>
              ) : (
                ""
              )}
            </p>
            <p className="repo-description" style={{ color: theme.text }}>
              {repo.description}
            </p>
            <div className="repo-details">
              <ProjectLanguages logos={repo.languages} />
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
}
